import type { PlannedPoint } from '../shared/contracts.js';

/** Endpoints do not consume stop numbers; the return shares the start's marker. */
export function mapMarkers(points: PlannedPoint[]) {
  let stopNumber = 0;
  return points.filter((point) => point.id !== 'return').map((point, index) => {
    const label = index === 0 ? 'S' : point.id === 'destination' ? 'D' : String(++stopNumber);
    const role = label === 'S' ? 'Start' : label === 'D' ? 'Destination' : `Stop ${label}`;
    return { point, label, title: `${role}: ${point.label}` };
  });
}
